var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDelete48Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 9.21953H20.0667C19.2667 7.67516 17.7333 6.66797 16 6.66797C14.2667 6.66797 12.7333 7.67516 11.9333 9.21953H8.66667C8.26667 9.21953 8 9.48811 8 9.89099C8 10.2939 8.26667 10.5625 8.66667 10.5625H9.33333V24.6632C9.33333 25.0661 9.6 25.3346 10 25.3346H22C22.4 25.3346 22.6667 25.0661 22.6667 24.6632V10.5625H23.3333C23.7333 10.5625 24 10.2939 24 9.89099C24 9.48811 23.7333 9.21953 23.3333 9.21953ZM16 8.01089C17 8.01089 17.8667 8.48092 18.5333 9.21953H13.5333C14.1333 8.48092 15 8.01089 16 8.01089ZM21.3333 23.9917H10.6667V10.5625H21.3333V23.9917Z",
    stroke: "#808080",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0007 13.918C17.6007 13.918 17.334 14.1866 17.334 14.5894V20.6326C17.334 21.0355 17.6007 21.3041 18.0007 21.3041C18.4007 21.3041 18.6673 21.0355 18.6673 20.6326V14.5894C18.6673 14.1866 18.4007 13.918 18.0007 13.918Z",
    stroke: "#808080",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 13.918C13.6007 13.918 13.334 14.1866 13.334 14.5894V20.6326C13.334 21.0355 13.6007 21.3041 14.0007 21.3041C14.4007 21.3041 14.6673 21.0355 14.6673 20.6326V14.5894C14.6673 14.1866 14.4007 13.918 14.0007 13.918Z",
    stroke: "#808080",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete48Px);
export default __webpack_public_path__ + "static/media/ic_delete_48px.3d9e4805.svg";
export { ForwardRef as ReactComponent };